import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import styles from './index.module.scss';
import { Button, Tree, Table, Drawer, Form, Input, Radio, Select, DatePicker, Row, Col, InputNumber } from 'antd';
import { DeleteOutlined, RetweetOutlined } from '@ant-design/icons';
import { Chart } from '@antv/g2';
import { getData, getDimensions, overview } from '@/api/activity/activity';
import dayjs from 'dayjs';
import { download } from '@/api/network';

const { RangePicker } = DatePicker;

const TrackData = () => {
  const [searchParams] = useSearchParams();
  const [trackTimeLine, setTrackTimeLine] = useState([] as any);
  const [addValue, setAddValue] = useState(null as any);
  const [dataType, setDataType] = useState(2);
  const [data, setData] = useState([] as any);
  const [page, setPage] = useState({ pageSize: 10, pageNum: 1, total: 0 });
  const activityId = searchParams.get('activityId') || '';
  const today = dayjs().format('YYYY-MM-DD');
  const thirtyDaysAgo = dayjs().subtract(30, 'day').format('YYYY-MM-DD');
  const [trackData, setTrackData] = useState([] as any);
  const [dimensions, setDimensions] = useState([] as any);
  const [clickType, setClickType] = useState(1); //1查询 2导出

  const options = [
    { label: 'pv', value: 1 },
    { label: 'uv', value: 2 },
  ];

  const columns = [
    {
      title: 'oneId',
      dataIndex: 'activityId',
      key: 'activityId',
    },
    {
      title: '平台ID',
      dataIndex: 'activityId',
      key: 'activityId',
    },
    {
      title: '埋点类型',
      dataIndex: 'activityId',
      key: 'activityId',
    },
    {
      title: '埋点参数',
      dataIndex: 'activityId',
      key: 'activityId',
    },
    {
      title: '发生时间',
      dataIndex: 'activityId',
      key: 'activityId',
    },
  ];

  const trackOptions = [
    {
      value: '1',
      label: '埋点1',
    },
    {
      value: '2',
      label: '埋点2',
    },
    {
      value: '3',
      label: '埋点3',
    },
    {
      value: '4',
      label: '埋点4',
    },
    {
      value: '5',
      label: '埋点5',
    },
  ];

  const [charData, setCharData] = useState({} as any);

  useEffect(() => {
    // const data = [
    //   { action: '浏览网站', pv: 50000 },
    //   { action: '放入购物车', pv: 35000 },
    //   { action: '生成订单', pv: 25000 },
    //   { action: '支付订单', pv: 15000 },
    //   { action: '完成交易', pv: 8000 },
    // ];
    // const chart = new Chart({
    //   container: 'container',
    //   autoFit: true,
    //   paddingRight: 80,
    // });
    // chart.coordinate({
    //   transform: [{ type: 'transpose' }],
    // });
    // chart.data({
    //   type: 'inline',
    //   value: data,
    //   transform: [
    //     {
    //       type: 'custom',
    //       callback: (data: any) => data.map((d: any) => ({ ...d, rate: d.pv / data[0].pv })),
    //     },
    //   ],
    // });
    // chart
    //   .interval()
    //   .encode('x', 'action')
    //   .encode('y', 'pv')
    //   .encode('color', 'action')
    //   .encode('shape', 'pyramid')
    //   .transform({ type: 'symmetryY' })
    //   .scale('x', { padding: 0 })
    //   .animate('enter', { type: 'fadeIn' })
    //   .label({
    //     text: (d: any) => `${d.action} ${d.pv}`,
    //     textAlign: 'left',
    //   })
    //   .label({
    //     text: (d: any) => `${(d.rate * 100).toFixed(1)}%`,
    //     position: 'inside',
    //     transform: [{ type: 'contrastReverse' }],
    //   })
    //   .legend('color', { position: 'bottom' })
    //   .axis(false);
    // chart.render();
  }, []);

  const [form] = Form.useForm();
  const onFinish = (values: any) => {
    console.log('Received values of form: ', values);
    console.log(clickType);
    if (clickType === 1) {
      if (values.time) {
        getActivityData({
          activityId,
          startDate: values.time[0].format('YYYY-MM-DD'),
          endDate: values.time[1].format('YYYY-MM-DD'),
          dimensions: values.dimensions || '',
        });
      } else {
        getActivityData({
          activityId,
          startDate: thirtyDaysAgo,
          endDate: today,
          dimensions: values.dimensions || '',
        });
      }
    } else {
      if (values.time) {
        download(
          `/member/royalcanin/admin/activity/data/trend/export?activityId=${activityId}&startDate=${values.time[0].format('YYYY-MM-DD')}&endDate=${values.time[1].format('YYYY-MM-DD')}&dimensions=${values.dimensions || ''}`,
        );
      } else {
        download(
          `/member/royalcanin/admin/activity/data/trend/export?activityId=${activityId}&startDate=${thirtyDaysAgo}&endDate=${today}&dimensions=${values.dimensions || ''}`,
        );
      }
    }
  };

  const draw = (res: any, type: string) => {
    let arr: any = [];
    for (let i = 0; i < res.data.dates.length; i++) {
      const date = res.data.dates[i];
      res.data.series.map((item: any) => {
        let o: any = {
          date,
          name: item.name,
          value: type === 'pv' ? item.pvData[i] : item.uvData[i],
        };
        arr.push(o);
      });
    }

    const chart = new Chart({
      container: 'dataChart',
      autoFit: true,
    });

    chart
      .interval()
      .data(arr)
      // .transform({ type: 'sortX', by: 'y', reverse: true, })
      .transform({ type: 'dodgeX' })
      .encode('x', 'date')
      .encode('y', 'value')
      .encode('color', 'name')
      .scale('y', { nice: true })
      .axis('x', { title: '日期' })
      .axis('y', { title: '人数', labelFormatter: '~d' })
      .scrollbar('x', {});

    chart.interaction('tooltip', { shared: true }).interaction('elementHighlightByColor', { background: true });

    chart.render();
  };

  const getActivityData = async (data: any) => {
    const res: any = await getData(data);
    setCharData(res);
    draw(res, 'pv');
    // setData(res.rows);
    // setPage({
    //   ...page,
    //   total: res.total,
    // })
  };

  const featureDataGen = (data: any) => {
    const chart = new Chart({
      container: 'dataChart',
      autoFit: true,
    });

    chart
      .interval()
      .coordinate({ transform: [{ type: 'transpose' }] })
      .data(data)
      .encode('x', 'functionName')
      .encode('y', 'value')
      .encode('color', 'key')
      .transform({ type: 'dodgeX' })
      .interaction('tooltip', { shared: true });

    chart.render();
  };

  useEffect(() => {
    getOverview();
    getDimensionsList();
    getActivityData({
      activityId,
      startDate: thirtyDaysAgo,
      endDate: today,
    });
  }, []);

  const getDimensionsList = async () => {
    const res: any = await getDimensions();
    setDimensions(res.data.data);
  };

  const getOverview = async () => {
    const res: any = await overview({ activityId });
    console.log(res);
    setTrackData(res.data.metrics);
    // setOverview(res)
  };

  const [radioValue, setRadioValue] = useState(1);

  return (
    <div style={{ padding: '32px 0 0 16px' }}>
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: 16 }}>
        <div style={{ fontSize: 18, fontWeight: 'bold', color: '#000000' }}>活动数据</div>
        <Radio.Group
          options={options}
          onChange={(e: any) => {
            setRadioValue(e.target.value);
            draw(charData, e.target.value === 1 ? 'pv' : 'uv');
          }}
          value={radioValue}
          optionType="button"
          buttonStyle="solid"
          size="small"
          style={{ marginLeft: 16 }}
        />
      </div>
      <div style={{ height: 'calc(100% - 50px)', display: 'flex', flexDirection: 'row' }}>
        {/* <div className={styles['leftContainer']}>
          <div>数据自定义下站</div>
          <div className={styles['tags']}>
            <div style={{ fontSize: 12 }}>埋点时序：</div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              {trackTimeLine.map((item: any, index: number) => (
                <div style={{ display: 'flex', flexDirection: 'row', fontSize: 12, marginBottom: 8, alignItems: 'center' }}>
                  <div>{index + 1}、</div>
                  <Select size="small" value={item.value} options={trackOptions}></Select>
                  <Button size="small" type="link" icon={<DeleteOutlined />} onClick={() => {
                    const newTrackTimeLine = trackTimeLine.filter((_: any, i: number) => i !== index);
                    setTrackTimeLine(newTrackTimeLine);
                  }}></Button>
                </div>
              ))}
              {trackTimeLine.length < 5 && <div style={{ display: 'flex', flexDirection: 'row', fontSize: 12, alignItems: 'center', marginBottom: 8 }}>
                <div>{trackTimeLine.length + 1}、</div>
                <Select size="small" value={addValue} placeholder="选择埋点" options={trackOptions} onChange={(value) => { let a = { value }; let arr = [...trackTimeLine, a]; setTrackTimeLine(arr) }}></Select>
              </div>}
            </div>
          </div>
          <div className={styles['tags']} style={{ alignItems: 'center', marginTop: 8 }}>
            <div style={{ fontSize: 12 }}>统计时间：</div>
            <RangePicker size="small" />
          </div>
          <div style={{ float: 'right', marginRight: 16, display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'flex-end', marginTop: 8 }}>
            <Button size="small">重置</Button>
            <Button type="primary" size="small" style={{ margin: '0 16px' }}>查询</Button>
          </div>
          <div id='container' style={{ marginTop: 32, marginLeft: 'auto', marginRight: 'auto', width: 300, height: 320 }}></div>
        </div> */}
        <div className={styles['right-container']}>
          <div className={styles['dataHeader']}>
            <div className={styles['list']}>
              {trackData.map((item: any) => (
                <div className={styles['item']}>
                  <div>{radioValue === 1 ? item.pv : item.uv}</div>
                  <div style={{ fontSize: 16, marginTop: 8, marginLeft: 8, marginRight: 8, textAlign: 'center' }}>
                    {item.label}
                  </div>
                </div>
              ))}

              {/* <div className={styles['item']}>
                <div>39999</div>
                <div style={{ fontSize: 16, marginTop: 8 }}>参与活动</div>
              </div>
              <div className={styles['item']}>
                <div>39999</div>
                <div style={{ fontSize: 16, marginTop: 8 }}>参与活动</div>
              </div> */}
            </div>
          </div>

          {/* <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginLeft: 32, marginTop: 32 }}>
            <div>{dataType === 1 ? '明细数据' : '图表模式'}</div>
            <Button size='small' type='link' icon={<RetweetOutlined />} onClick={() => { setDataType(dataType === 1 ? 2 : 1) }}>切换为{dataType === 1 ? '图表' : '明细'}</Button>
          </div> */}

          <Form
            form={form}
            name="advanced_search"
            className="ant-advanced-search-form"
            onFinish={onFinish}
            style={{ margin: '16px 32px 0 32px' }}>
            <Row gutter={32}>
              <Col span={8}>
                <Form.Item
                  name="dimensions"
                  label="数据维度">
                  <Select
                    placeholder="请选择数据维度"
                    options={dimensions}
                    fieldNames={{ label: 'label', value: 'key' }}></Select>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  name="time"
                  label="发生时间">
                  <RangePicker />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Button
                  onClick={() => {
                    form.resetFields();
                  }}>
                  重置
                </Button>
                <Button
                  style={{ margin: '0 8px' }}
                  type="primary"
                  onClick={() => {
                    setClickType(1);
                    form.submit();
                  }}>
                  查询
                </Button>
                <Button
                  type="primary"
                  onClick={() => {
                    setClickType(2);
                    form.submit();
                  }}>
                  导出
                </Button>
              </Col>
            </Row>
          </Form>

          {dataType === 1 && (
            <Table
              columns={columns}
              dataSource={data}
              style={{ margin: '0 32px' }}
              pagination={{
                pageSize: page.pageSize,
                current: page.pageNum,
                total: page.total,
                onChange: (pageNum, pageSize) => {
                  setPage({ ...page, pageNum, pageSize });
                },
              }}></Table>
          )}
          {dataType === 2 && (
            <div
              id="dataChart"
              style={{ margin: '0 32px' }}></div>
          )}
        </div>
      </div>
    </div>
  );
};
export default TrackData;
